export const durationFilterTypes: Set<string> = new Set([
  "launch_time",
  "volume_age",
  "start_date",
  "age",
]);
